import { Injectable } from '@angular/core';
import {GeneralService} from "../../../services/general-delete.service";
import {HttpClient} from "@angular/common/http";
import {StorageService} from "front-common-toolkits";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class TenantMenuService extends GeneralService {

  constructor(
    public http: HttpClient,
    private storageService: StorageService
  ) {
    super(http);

    this.setModelPath('/ten/menu');
  }

  getMenus() {
    return this.searchByPage(1).pipe(map(res => res['data']));
  }

  getTenantMenus() {
    return this.http.get(this.httpBase + '/ten/auth/user/menu').pipe(map(res => res['data'] ? res['data'] : []));
  }
}
